import React from 'react'

import { connect } from 'react-redux'

import ActionCable from 'actioncable'

import { insertNewWorkOrder, fetchWorkOrder, removeDeletedWorkOrder } from '../../actions/work-orders'

import Echo from 'laravel-echo'

function mapStateToProps(state, ownProps) {
  const { session } = state.auth
  let token = ''

  if (session && session.hasOwnProperty('token')) {
    token = session.token
  }

  return {
    token
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onData(data) {
      switch (data.type) {
        case 'created':
          return dispatch(insertNewWorkOrder(data.work_order_id))
        case 'updated':
          return dispatch(fetchWorkOrder(data.work_order_id))
        case 'destroyed':
          return dispatch(removeDeletedWorkOrder(data.work_order_id))
      }
    }
  }
}

const Mountable = React.createClass({
  componentDidMount() {
    // this.cable = ActionCable.createConsumer(process.env.ACTIONCABLE_URL + `?token=${this.props.token}`)

    // this.subscription = this.cable.subscriptions.create('WorkOrderChannel', {
    //   received: this.props.onData
    // })

    // window.Pusher = require('pusher-js');

    // window.Echo = new Echo({
    //   broadcaster: 'pusher',
    //   key: process.env.PUSHER_APP_KEY,
    //   cluster: process.env.PUSHER_APP_CLUSTER,
    //   forceTLS: true,
    //   authEndpoint: (process.env.API_ENDPOINT.replace('/api', '')) + '/broadcasting/token-auth',
    //   auth: {
    //     headers: {
    //       "X-Auth-Token": this.props.token,
    //     },
    //   },
    // });

    window.Echo.private("Notifications.WorkOrders")
      .listen("WorkOrderNotification", (e) => {
        this.props.onData(e.data);
      });
  },

  componentWillUnmount() {
    // this.subscription.unsubscribe()
    // this.cable.disconnect()

    window.Echo.private("Notifications.WorkOrders")
      .stopListening("WorkOrderNotification");

    window.Echo.leave("Notifications.WorkOrders");

    // window.Echo.disconnect();
  },

  render: () => null
})

export default connect(mapStateToProps, mapDispatchToProps)(Mountable)



// WEBPACK FOOTER //
// ./src/components/work-orders/live-work-order-channel.js